// GENERATED FILE. Do not edit by hand. Produced by `bun run codegen` from
// x-flags.doRenderReactQueryQueryHook on POST /reaction/list.

import { useQuery, type UseQueryOptions } from "@tanstack/react-query";
import type {
  typeReactionListBody,
  typeReactionListOutput200,
} from "../../sdk/reaction/postReactionList";
import useCallSdk from "../../sdk-helpers/useCallSdk";

export function buildReactionListQueryKey(
  payload: typeReactionListBody,
): string[] {
  const queryKeySegments: string[] = [];
  queryKeySegments.push(`messageId:${JSON.stringify(payload.messageId)}`);
  if (typeof payload.emoji !== "undefined") {
    queryKeySegments.push(`emoji:${JSON.stringify(payload.emoji)}`);
  }
  if (typeof payload.cursor !== "undefined") {
    queryKeySegments.push(`cursor:${JSON.stringify(payload.cursor)}`);
  }
  if (typeof payload.limit !== "undefined") {
    queryKeySegments.push(`limit:${JSON.stringify(payload.limit)}`);
  }
  return [
    "post:reaction:reactionList",
    "svc:messaging-api",
    ...queryKeySegments,
  ];
}

type QueryOptions = Partial<
  UseQueryOptions<
    typeReactionListOutput200,
    unknown,
    typeReactionListOutput200,
    string[]
  >
> & {
  // Isolates two callers that query the same data for independent UI state
  // (e.g. a dropdown search vs a table both listing the same resource).
  queryKeyIdentifier?: string;
};

export default function useReactionList(
  payload: typeReactionListBody,
  options?: QueryOptions,
) {
  // No staleTime default here on purpose. Freshness is the consuming app's
  // decision and belongs in its QueryClient, in one place: a default set on the
  // hook would silently beat it for every screen. Pass one per call to override.
  const resolvedOptions = options ?? {};

  let queryKey = buildReactionListQueryKey(payload);
  if (resolvedOptions.queryKeyIdentifier) {
    queryKey = [...queryKey, resolvedOptions.queryKeyIdentifier];
  }

  const { callSdk } = useCallSdk();
  return useQuery({
    queryKey,
    queryFn: () => callSdk().postReactionList(payload),
    ...resolvedOptions,
  });
}
